// extracted by mini-css-extract-plugin
module.exports = {"sort-btn":"PlanTableHeader_sort-btn__3sw87","sort-icon":"PlanTableHeader_sort-icon__3SO8T"};